import { Dispatch, SetStateAction, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import Rolling from '@assets/gif/rolling.gif';

import { ITagLimitWithDesc } from '@models/Tag.model';
import { useSearchFilteredTags } from '../../AssignTag.hooks';
import { pageToTagData, ToTagList } from '../../AssignTag.utils';
import { Container, LoadingImg, LoadingText, LoadMore } from './Tags.styles';

interface ITagsProps {
  tagCategoryId: string;
  searchText: string;
  activeList: Pick<ITagLimitWithDesc, 'id'>[];
  selectedTags: ITagLimitWithDesc[];
  setSelectedTags: Dispatch<SetStateAction<ITagLimitWithDesc[]>>;
}

function Tags(props: ITagsProps) {
  const {
    searchText,
    tagCategoryId,
    activeList,
    selectedTags,
    setSelectedTags,
  } = props;
  const {
    data,
    isLoading,
    isError,
    fetchNextPage: newFetchNextPage,
  } = useSearchFilteredTags(searchText, tagCategoryId);

  const tagsData = pageToTagData(data);

  const hasMore = data ? data.pages[data.pages.length - 1].hasMore : false;

  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView && hasMore) newFetchNextPage();
  }, [inView, hasMore]);

  if (!data || isError) {
    <div>error</div>;
  }
  if (isLoading) {
    <div />;
  }
  return (
    <Container>
      {tagsData.map(ToTagList(activeList, selectedTags, setSelectedTags))}
      <LoadMore ref={ref}>
        {hasMore ? (
          <LoadMore>
            <LoadingText>Loading more</LoadingText>
            <LoadingImg src={Rolling} alt="loading" />
          </LoadMore>
        ) : (
          <div />
        )}
      </LoadMore>
    </Container>
  );
}

export { Tags };
